export interface PasswordStrength {
  score: 0 | 1 | 2 | 3; // 0 too short, 1 weak, 2 medium, 3 strong
  label: 'Too short' | 'Weak' | 'Medium' | 'Strong';
}

/** Lightweight, dependency-free strength heuristic: length + character-class variety. */
export function scorePassword(password: string): PasswordStrength {
  if (password.length < 8) return { score: 0, label: 'Too short' };

  let variety = 0;
  if (/[a-z]/.test(password)) variety++;
  if (/[A-Z]/.test(password)) variety++;
  if (/[0-9]/.test(password)) variety++;
  if (/[^a-zA-Z0-9]/.test(password)) variety++;

  const long = password.length >= 12;
  if (long && variety >= 3) return { score: 3, label: 'Strong' };
  if (variety >= 3 || (long && variety >= 2)) return { score: 2, label: 'Medium' };
  return { score: 1, label: 'Weak' };
}
